import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { getServiceStatus } from '../../../angular-wallet-base/store/connection';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';

@Component({
  selector: 'app-system-status',
  templateUrl: './system-status.component.html',
  styleUrls: ['./system-status.component.scss'],
})
export class SystemStatusComponent implements OnInit {
  public services;
  protected subscriptions = new Subscription();
  public versionStr;
  public status;

  constructor(protected store: Store<AppState>,
  ) {
    this.subscriptions.add(this.store.select(getServiceStatus).subscribe(data => {
      this.services = data;
      Logger.info(this.services)
    }));
    const pjson = require('../../../../../package.json');
    const commitHash = require('../../../../commithash');
    this.versionStr = `${pjson.version}-${commitHash.hash.hash.substr(0, 16)}`;
  }

  ngOnInit() { }
}
